import {DrawerUp} from "@/components/mui";
import {Stack, IconButton, Box, Drawer} from '@mui/material'
import {languageOptions} from "@/utils/utils";
import classes from "./index.module.less";
import RpIcon from "@/components/RpIcon";
import React, {useContext} from "react";
import {SettingsContext} from "@/SettingsProvider";
import {changeLocale} from "@/utils/dateUtils";
import {useTranslation} from "react-i18next";
import axiosInstance from '@/utils/axios';
import API from "@/constant/API";
import {dispatch} from "@/redux/store";
import {getCountries} from "@/redux/slices/app";

interface MobileLanguageSelectorProps {
  open: boolean;
  onClose: () => void;
}

const MobileLanguageSelector = ({open, onClose,}: MobileLanguageSelectorProps) => {
  const {t, i18n} = useTranslation();
  const {
    updateSetting,
    settings,
  } = useContext(SettingsContext)

  const handleChangeLanguage = (language) => {
    const newSettings = {
      lang: language,
    }
    // onClose()

    // ar will using rtl direction layout.
    if (language === 'ar') {
      newSettings.direction = 'rtl'
    } else {
      newSettings.direction = 'ltr'
    }

    i18n.changeLanguage(language)
    changeLocale(language)
    updateSetting(newSettings)
    axiosInstance.post(API.USER_CHANGE_LOCALE).then(res => {

    });
    dispatch(getCountries());
  }

  return (<>
    <Drawer open={open} onClose={onClose} PaperProps={{sx: {width: '100vw', height: '100vh', maxWidth:'520px'}}}>
      <Box>
        <Stack direction="row" alignItems="center" className={classes.header}>
          {/*<Typography className={classes.headerText}>Account Settings</Typography>*/}
          <Box onClick={onClose}>
            <RpIcon icon="arrow-left" size={20} />
          </Box>
          <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
            <span className={classes.text}>{t('language')}</span>
          </Box>
        </Stack>
        <Box>
        {
            Object.keys(languageOptions).map(key => {
              const { label } = languageOptions[key];
              return (
                <Box className={classes["list-warp"]} key={key} onClick={() => handleChangeLanguage(key)}>
                  <Stack className={classes["list-content"]} alignItems="center" direction="row" justifyContent="space-between">
                    <span>{label}</span>
                    {key === settings.lang&&<RpIcon icon="check-circle-full" size={20}/>}
                  </Stack>
                </Box>
              )
            })
          }
        </Box>
      </Box>

    </Drawer>
  </>)
}

export default MobileLanguageSelector